module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subheader",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "padding-top": "0rem",
      "padding-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-11 wrapper",
    class: [{
      'has-text-left': !_vm.textAlign || _vm.textAlign === 'left',
      'has-text-centered': _vm.textAlign === 'center',
      'has-text-right': _vm.textAlign === 'right'
    }]
  }, [_c('h1', {
    style: (_vm.titleStyle)
  }, [_vm._v(_vm._s(_vm.title))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d823ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageSubheader.vue
// module id = 903
// module chunks = 1